module.exports = __webpack_public_path__ + "static/media/workshop.2aa301bc.svg";